import { Component } from "binder";
import { getAsBoolean } from "../../utilities";
import { ColumnViewModel } from "../column/column-viewModel";

export abstract class ColumnFilter extends Component{
    public set isActive(v: boolean) { this._isActive =getAsBoolean(v); } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set column(v: ColumnViewModel) { this._column = v; } public get column(): ColumnViewModel { return this._column;} private _column: ColumnViewModel;
    
    apply(){
        this.column.filterChanged();
    }
}

